import React, {useMemo, useState} from "react";
import Link from "next/link";
import { makeStyles } from 'tss-react/mui';

// core components
import Header from "../components/Header/Header.js";
import Footer from "../components/Footer/Footer.js";
import GridContainer from "../components/Grid/GridContainer.js";
import Card from "../components/Card/Card.js";
import GridItem from "../components/Grid/GridItem.js";
import HeaderLinks from "../components/Header/HeaderLinks.js";
import Parallax from "../components/Parallax/Parallax.js";
import logo from "../public/img/logo.png";

import styles from "../styles/jss/nextjs-material-kit/pages/employersStyle.js";

import {useUniversitiesListRequest} from "../request/api";

// Sections for this page
import PreFooter from "../pages-sections/LandingPage-Sections/PreFooter.js";
import {buildSlug} from "../util/url";
import OrgSortBar from "../pages-sections/Components-Sections/employerDynamicSearch";
import Head from "next/head";
import JSONSchemaData from "../components/JSONSchemaData/JSONSchemaData";

const dashboardRoutes = [];
const logoImg = "<img src=" + logo + "/>";

const useStyles = makeStyles()(styles);

export default function Universities(props) {
  const { classes, cx } = useStyles();
  const { ...rest } = props;

  const { data, error, isLoading } = useUniversitiesListRequest();

  const [sortOrder, setSortOrder] = useState('Top');
  const [indexingDone, setIndexingDone] = useState(false);

  const sortedUniversities = useMemo(() => {
    if (!data?.universities || !indexingDone) {
      return [];
    }
    const _sortedUniversities = [...data.universities];
    _sortedUniversities.sort((a, b) => {
      if (sortOrder === 'Top') {
        return b.natural_order_index - a.natural_order_index;
      } else if (sortOrder === 'A-Z') {
        return a.name.localeCompare(b.name);
      } else {
        console.log('Unsupported sort type: ' + sortOrder);
      }
    });
    return _sortedUniversities;
  }, [data?.universities, indexingDone, sortOrder]);

  if (data?.universities?.length > 0 && !indexingDone) {
    data.universities = data.universities.map((university, ii) => {
      university.natural_order_index = ii;
      return university;
    });
    setIndexingDone(true);
  }

  const jsonBreadcrumbData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [{
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://successatschool.org/"
    }, {
      "@type": "ListItem",
      "position": 2,
      "name": "Universities",
      "item": "https://successatschool.org/universities"
    }]};

  return (
    <div className={cx(classes.white_bg, "careerZoneSlide")}>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        logo={logo}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white",
        }}
        {...rest}
      />
      <Head>
        <link rel="canonical" href="https://successatschool.org/universities" />
        <title>Universities - Success at School</title>
      </Head>
      <Parallax className="parallaxx-compact" filter image="/img/faces/universities_img.png">
        <h1 className={cx(classes.title, "title")}>
          Universities
        </h1>
        <br />
      </Parallax>
      <div className={cx(classes.section, classes.white_bg, "jobbs")}>
        <div className={cx(classes.container)}>
          <h1
            style={{ fontSize: "60px" }}
            className={cx(
              classes.title,
              classes.title_cap,
              classes.cardTitle
            )}
          >
            Top universities
          </h1>

          <div
              style={{ padding: "11px 30px" }}
              id="inputs"
              className={[classes.search_section, "search_section"].join(" ")}
          >
            <OrgSortBar sortChosen={setSortOrder} />
          </div>
          <div className={classes.space70} />
          <br />
        </div>
      </div>
      <div className={classes.container}>
        <div
          className={cx(
            classes.white_bg,
            classes.fullMaxWidth,
            "colored_bgg"
          )}
        >
          <GridContainer>
            {sortedUniversities.length > 0 ? sortedUniversities.map((university, ii) => {
              return (
                // First 2 orgs get more prominent grid space on desktop
                <GridItem
                  key={`university-${university.id}`}
                  className={classes.employerCardOuter}
                  xs={12}
                  sm={12}
                  md={ii < 2 ? 6 : 3}
                >
                  <Link href={`/university/${buildSlug(university.name)}/${university.id}`}>
                    <Card className={cx(classes.employerCard, "link", "jobcard")}>
                      <GridItem
                        xs={12}
                        sm={12}
                        md={12}
                        className={cx(classes.cardLogoContainer)}
                      >
                        <div
                          className={cx(classes.cardLogo)}
                          style={{
                            backgroundImage: `url(${university.logo_uri})`
                          }}
                        ></div>
                      </GridItem>
                      <GridItem
                        className={classes.floatLeft}
                        xs={12}
                        sm={12}
                        md={12}
                      >
                        <h4
                          style={{ textAlign: "center" }}
                          className={cx(
                            classes.cardTitle,
                            classes.cardDesc
                          )}
                        >
                          {university.name}
                        </h4>
                      </GridItem>
                    </Card>
                  </Link>
                </GridItem>
              );
            }) : null}
          </GridContainer>
          <br></br>
          <br></br>
        </div>
      </div>
      <div className={cx(classes.darkBlue, "footer", "colored_bgg")}>
        <PreFooter />
      </div>
      <Footer />
      <JSONSchemaData key_name={'breadcrumbSchema'} data={jsonBreadcrumbData} />
    </div>
  );
}
